import React from 'react';

import { Card } from 'ui';

import TransportDetail from './TransportDetail';

type Props = {
  ticket: BackendPublic.TicketDetail;
};

function TransportList({ ticket }: Props) {
  if (!ticket.transports || ticket.transports.length === 0) return null;

  return (
    <Card flat>
      <Card.Content>
        <div className="space-y-4">
          {ticket.transports
            .filter((transport) => transport.status !== 'STATUS_CANCELED')
            .map((transport) => (
              <TransportDetail transport={transport} />
            ))}
        </div>
      </Card.Content>
    </Card>
  );
}

export default TransportList;
